import { render } from "./EditPageContentPreview.vue?vue&type=template&id=001a8a1b&scoped=true"
import script from "./EditPageContentPreview.vue?vue&type=script&lang=js"
export * from "./EditPageContentPreview.vue?vue&type=script&lang=js"

import "./EditPageContentPreview.vue?vue&type=style&index=0&id=001a8a1b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001a8a1b"]])

export default __exports__